import axios from "axios";
import env from "../../constants/apiConst";

export const __Balance = async (token) => {
  const res = await axios({
    method: "POST",
    url: env.TREASURY_BALANCE,
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return res;
};
